<template>
<div>
<p class="text-primary" v-if="column.type=='text' || column.type=='longtext' || column.type=='number'">
{{output}}
</p>

<Tag 
v-if="column.type=='select' && output"
class="ml-2  mb-2 custom-chip" 
:value="output.name" 
:style="'background-color:#'+output.color"
/> 

</div>

</template>

<script>
export default {

  name: 'SuppliersTableAttributeColumn',
  props:["column","row"],
  data () {
    return {

    }
  },
  computed:{
  	output()
  	{
  		if(this.column)
  		{
  			/*
  			console.log("column")
  			console.log(this.column.fulloptions)
  			*/
  			let output
  			let attr_name = this.column.id+"_"+this.column.type
  			let row_data = this.row[attr_name]
  			if(this.column.type=="text" || this.column.type=="longtext"|| this.column.type=="number")
  			{
  				 output = row_data
  			}
  			if(this.column.type=="select")
  			{
  				 let option = this.column.fulloptions.find(item=>item.id == row_data)
  				 if(option)
  				 {
  				 	/*
  				 	console.log("option")
  				 	console.log(row_data)
  				 	console.log(option.id)
  				 	console.log(option.name)
  				 	*/
  				 	
  				 	output = {
  				 		name:this.getTheTranslation(option,"translation"),
  				 		color:"3b82f6"
  				 	}  				 	
  				 	if(option.color)
  				 	{
  				 		output.color = option.color
  				 	}
  				 }
  			}
  			if(this.column.type=="multiselect")
  			{

  			}

  			

  			return output
  		}
  		return null
  	},
  }
}
</script>

<style lang="css" scoped>
</style>